
export default class PackageModel {
  constructor ( 
    _id = 1,
    _tracking = "",
    _guide = "",
    _customer = "",
    _tax = {},
    _unit = { code: 'lb', name: "Libras" },
    _weight = "",
    _price = "",
    _resource = "",
    _delivery = {},
    _comments = "",
    _history = "",
    _courier = "",
    _customerType = "",
    _user = "",
    _paidOut = 0,
    _finalized = 0,
    _cardName  = "",
    _cardNumber  = "",
    _cardExp  = "",
    _cardCVC  = "",
    _createdAt = "",
    _status    = { id: 2, name: "PreAlerta"}
  ){

    this.id        = _id,
    this.tracking  = _tracking,
    this.guide     = _guide,
    this.customer  = _customer,
    this.tax       = _tax,
    this.unit      = _unit,
    this.weight    = _weight,
    this.price     = _price,
    this.resource  = _resource,
    this.delivery  = _delivery,
    this.comments  = _comments,
    this.history   = _history,
    this.courier   = _courier,
    this.customerType = _customerType,
    this.user      = _user,
    this.paidOut   = _paidOut,
    this.finalized = _finalized,
    this.cardName  = _cardName,
    this.cardNumber= _cardNumber,
    this.cardExp   = _cardExp,
    this.cardCVC   = _cardCVC,
    this.createdAt = _createdAt,
    this.status    = _status
 }

}  

